import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/empty_state_icon.svg'


const _hoisted_1 = {
  class: "card card-inactive text-muted border-2 bg-lighter",
  id: "empty-state-container"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "text-body-secondary text-center mt-2" }


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
    title: { default: 'Nenhum item encontrado' },
    message: { default: 'Nenhum item disponível ainda. Quando houver, você verá aqui!' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-center" }, [
        _createElementVNode("img", {
          width: "32",
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.message), 1)
    ])
  ]))
}
}

})